<template>
	<AppModal @hide-modal="$emit('hideModal')">
		<template #header>Notities</template>

		<AppModalContent>
			<div class="alert-banner" style="align-self: start">
				<span class="ht-icon">info_i</span>
				<span style="align-self: flex-start">
					Alleen adviseurs kunnen deze notities lezen
				</span>
			</div>
			<textarea
				ref="modalTextarea"
				v-model="notes"
				class="notities-modal-textarea"
			/>
			<pre v-if="notes && showValues">{{ notes }}</pre>
		</AppModalContent>
	</AppModal>
</template>

<script lang="ts" setup>
import { useDossierNotes } from "@/composables/useDossierNotes";
import { useDossierStore } from "@/store/useDossierStore";
import { storeToRefs } from "pinia";
import { inject, ref, watchEffect } from "vue";

defineEmits<{
	hideModal: [];
}>();

const dossierStore = useDossierStore();
const { selectedDossier } = storeToRefs(dossierStore);

const { notes } = useDossierNotes(() => selectedDossier.value?.versions?.id);
const showValues = inject("DEBUG_SHOW_MODELVALUES", false);

const modalTextarea = ref<HTMLTextAreaElement | null>(null);

watchEffect(() => {
	modalTextarea.value?.focus();

	modalTextarea.value?.setAttribute(
		"style",
		`height:${modalTextarea.value.scrollHeight}px;overflow-y:hidden;`,
	);
	modalTextarea.value?.addEventListener("input", onInput, false);
});

function onInput(this: any) {
	this.style.height = 0;
	this.style.height = `${this.scrollHeight}px`;
}
</script>

<style lang="scss">
.notities-modal-textarea {
	width: 100%;
	min-height: 100px;
	resize: vertical;
	border: 1px solid var(--border);
	border-radius: var(--border-radius);
}
</style>
